// bao migrate skip
import "./user-tagging.css";
import * as ko from "knockout";
import * as $ from "jquery";
import Tribute from "tributejs"
import Bao from "./../../services/bao-service";
import * as _debounce from "lodash/debounce";
export interface IUserTagging {
    UserTaggingId: string;
    EntityType: string;
    PropertyKey: string;
    EntityId: string;
    DisplayValueHtml: string;
}

export interface IUserTaggingMention {
    UserTaggingMentionId: string;
    UserTaggingId: string;
    UserId: string;
    HasRead: boolean;
}

export interface UserTaggingComponentParams {
    Enabled?: boolean | KnockoutObservable<boolean>;
    SkipValueLoading?: boolean | KnockoutObservable<boolean>;
    /*Usertagging list with list of mentioned users */
    UserTaggingsList: KnockoutObservableArray<IUserTaggingMention>;
    /*Value which will be show in input*/
    DisplayValue: KnockoutObservable<string>;
    /*Value which contains data about mentioned user in html */
    RawValue: KnockoutObservable<string>;
    /*Parent of the component */
    Parent: any;
    /*Brodcast table data*/
    EntityType: string;
    PropertyKey: string;
    EntityId: KnockoutObservable<string> | string;

    /*Attributes*/
    ReadOnly: KnockoutObservable<boolean> | boolean;
    IsMandatory: KnockoutObservable<boolean> | boolean;

    DirtyFlag: KnockoutDirtyFlag;
}
export class UserTaggingComponent {
    Element: HTMLElement;
    CarretPosition: number = -1;
    Params: UserTaggingComponentParams;
    SearchMode: boolean;
    IsSaving: boolean;
    UserTaggingId: string;
    tribute: Tribute<{}>;
    msgEmptyResults: KnockoutObservable<string>;
    currentSelection: Range;

    private _subscribes: KnockoutSubscription[] = [];
    constructor(params: UserTaggingComponentParams, componentElement: HTMLElement) {
        this.Params = params;
        this.Element = componentElement;

        // Strip tags on paste
        this.Element.querySelector("#userTaggingInput").addEventListener("paste", (e: ClipboardEvent) => {
            e.preventDefault();
            let text;
            if (e.clipboardData && e.clipboardData.getData) {
                text = e.clipboardData.getData("text/plain");
                document.execCommand("insertHTML", false, text);
            } else if (window["clipboardData"] && window["clipboardData"].getData) {
                text = window["clipboardData"].getData("Text");
                this.insertTextAtCursor(text);
            }
        });

        this.tribute = new Tribute({
            collection: [
                {
                    // Trigger character
                    trigger: "@",
                    // Template to be inserted on select
                    selectTemplate: function (item) {
                        if (item) {
                            if (this.range.isContentEditable(this.current.element)) {
                                let nameString = '';
                                if (item.original.Firstname && item.original.Lastname) {
                                    nameString += item.original.Firstname + ' ' + item.original.Lastname;
                                } else if (item.original.Firstname || item.original.Lastname) {
                                    nameString += item.original.Firstname ?? '';
                                    nameString += item.original.Lastname ?? '';
                                } else {
                                    nameString += item.original.Username;
                                }
                                return '<span class="mention" contenteditable="false" id=\"' + item.original.UserId + '\">@' + nameString + '</span>';
                            }
                            return "@" + item.original.name;
                        }
                        return null;
                    },
                    searchOpts: {
                        pre: '<span class="autocomplete-element-highlight">',
                        post: '</span>',
                        skip: false
                    },
                    selectClass: 'autocomplete-element-highlight',
                    // Debounce to prevent request spam
                    values: _debounce(this.getUsers, 300),
                    lookup: function (user) {
                        return (user.Firstname ?? '') + ' ' + (user.Lastname ?? '') + ' (' + user.Username + ')';
                    },
                    fillAttr: "Username",
                    containerClass: 'autocomplete-container',
                    itemClass: 'autocomplete-element',
                    menuItemTemplate: function (item) {
                        return '<i class="fas fa-user"></i> ' + item.string;
                    }
                }
            ],
            noMatchTemplate: () => { return '<li class="autocomplete-element">' + this.msgEmptyResults() + '</li>'; }
        });
        this.tribute.attach(this.Element.querySelector("#userTaggingInput"));
        this.InitControl();
    }

    getUsers(text, cb) {
        Bao.post("UserTagging/GetUsersByName", JSON.stringify({ searchString: text }), (result) => { cb(result); })
    }

    InitControl() {
        if (ko.unwrap(this.Params.SkipValueLoading) !== true) {
            this.GetUserTaggingRawValue();
        }
        this.msgEmptyResults = Bao.Session.GetMessage("msgNothingFound");
        let containerDiv: HTMLDivElement = this.Element.querySelector("#userTaggingInput");
        let readOnly = ko.unwrap(this.Params.ReadOnly);
        if (readOnly) {
            containerDiv.setAttribute('contentEditable', 'false');
        }
        let isMandatory = ko.unwrap(this.Params.IsMandatory);
        if (isMandatory) {
            containerDiv.classList.add('isMandatory');
        }
        this._subscribes.push(this.Params.RawValue.subscribe(newValue => {
            this.SetRawInputValue(newValue, containerDiv, false);
        }));
        Bao.bindEvent('user-tagging:save', this.Save);
        Bao.raiseEvent('user-tagging:loaded', { id: ko.unwrap(this.Params.EntityId) });

        $(containerDiv).blur((e) => {
            this.currentSelection = this.SaveSelection();
            this.ParseInputValues(containerDiv);
        });
        $(containerDiv).focus((e) => {
            this.RestoreSelection(this.currentSelection);
        });
        $(this.Element.querySelector("#userTaggingInput")).on('input', (e) => {
            this.Params.DirtyFlag.setDirty();
        });
        // it will check br is always the lastChild of contenteditable
        $(containerDiv).on("keyup mouseup", function () {
            if (!this.lastChild || this.lastChild.nodeName.toLowerCase() != "br") {
                this.appendChild(document.createElement("br"));
            }//it will use br instead of <div>
        }).on("keypress", function (e) {
            if (e.which == 13 && window.getSelection) {
                let selection = window.getSelection(),
                    range = selection.getRangeAt(0),
                    br = document.createElement("br");
                range.deleteContents();
                range.insertNode(br);
                range.setStartAfter(br);
                range.setEndAfter(br);
                range.collapse(false);
                selection.removeAllRanges();
                selection.addRange(range);
                return false;
            }
        });

    }
    /**
     * Will set the rawvalue for the user tagging input container 
     * */
    GetUserTaggingRawValue = () => {
        let containerDiv: HTMLDivElement = this.Element.querySelector("#userTaggingInput");
        Bao.post('UserTagging/GetRawValue', JSON.stringify({ entityId: ko.unwrap(this.Params.EntityId), propertyKey: this.Params.PropertyKey }), (result) => {
            if (this.Params.DirtyFlag) {
                this.Params.DirtyFlag.pause();
            }
            let rawValue = this.Params.DisplayValue();
            if (result && result.model) {
                let entityUpdateDate = new Date(ko.unwrap(this.Params.Parent?.UpdateDate ?? null))
                let userTaggingUpdateDate = new Date(result.model.UpdateDateIso)
                if (result.model.DisplayValueHtml != null && entityUpdateDate.getTime() <= userTaggingUpdateDate.getTime()) {
                    rawValue = result.model.DisplayValueHtml;
                }
                this.UserTaggingId = result.model.UserTaggingId;
            }
            this.Params.RawValue(rawValue);
            this.SetRawInputValue(this.Params.RawValue(), containerDiv);
            if (this.Params.DirtyFlag) {
                this.Params.DirtyFlag.resume();
            }
        });

    }
    Save = (value) => {
        if (!this.IsSaving && (!value?.entityId || ko.unwrap(this.Params.EntityId) === value.entityId)) {
            this.IsSaving = true;
            let userTaggingModel = ({ UserTaggingId: this.UserTaggingId, EntityType: this.Params.EntityType, PropertyKey: this.Params.PropertyKey, EntityId: ko.unwrap(this.Params.EntityId), DisplayValueHtml: this.Params.RawValue() });
            Bao.post("UserTagging/SaveUserTaggings", JSON.stringify({ userTaggingModel: userTaggingModel, userTaggings: this.Params.UserTaggingsList() }), (result) => {
                this.IsSaving = false;
            });
        }
    }

    SaveSelection = () => {
        if (window.getSelection) {
            let sel = window.getSelection();
            if (sel.getRangeAt && sel.rangeCount) {
                return sel.getRangeAt(0);
            }
        } else if (document.selection && document.selection.createRange) {
            return document.selection.createRange();
        }
        return null;
    }

    RestoreSelection = (range) => {
        if (range) {
            if (window.getSelection) {
                let sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(range);
            } else if (document.selection && range.select) {
                range.select();
            }
        }
    }

    SetRawInputValue(newValue: string, containerDiv: HTMLDivElement, innerHTMLRefresh = true) {
        if (innerHTMLRefresh === true)
            containerDiv.innerHTML = newValue;

        let childNodes = Array.from(containerDiv.childNodes);
        let userMentions: IUserTaggingMention[] = [];
        this.findUserTaggings(childNodes, userMentions);
        this.Params.DisplayValue(containerDiv.innerText);
        this.Params.UserTaggingsList(userMentions);
    }

    findUserTaggings(nodes: ChildNode[], mentions: IUserTaggingMention[]) {
        for (let node of nodes) {
            if (node.childNodes.length > 0)
                this.findUserTaggings(Array.from(node.childNodes), mentions);
            if (node.nodeType === Node.ELEMENT_NODE && node.nodeName === "SPAN") {
                let nodeAny: any = node;
                let item: IUserTaggingMention = { UserTaggingMentionId: "", UserTaggingId: this.UserTaggingId, UserId: nodeAny.id, HasRead: false };
                mentions.push(item);
            }
        }
    }

    ParseInputValues(containerDiv: HTMLDivElement) {
        this.Params.RawValue(containerDiv.innerHTML);
        this.SetRawInputValue(containerDiv.innerHTML, containerDiv, false);
    }

    private insertTextAtCursor(text) {
        var sel, range;
        if (window.getSelection) {
            sel = window.getSelection();
            if (sel.getRangeAt && sel.rangeCount) {
                range = sel.getRangeAt(0);
                range.deleteContents();
                range.insertNode(document.createTextNode(text));
            }
        } else if (document.selection && document.selection.createRange) {
            document.selection.createRange().text = text;
        }
    }
}